import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Slide from '@material-ui/core/Slide';
import { Grid } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import { useForm } from "react-hook-form";
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { ReactHookFormSelect } from "./";



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddDoctor(props) {
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { register, handleSubmit, control, errors } = useForm();
    //const [phoneCode] = useState('+58');

    const saveLaboratory = async (admin) => {

    }

    return (
        <Dialog
            maxWidth="sm"
            fullScreen={fullScreen}
            open={props.open}
            TransitionComponent={Transition}
        >
            <IconButton aria-label="close" className={classes.closeButton} onClick={props.close} >
                <CloseIcon />
            </IconButton>
            <DialogTitle className={classes.dialogTitle}>Agregar doctor</DialogTitle>
            <DialogContent>
                <form className={classes.form} onSubmit={handleSubmit(saveLaboratory)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="name"
                                label="Nombre"
                                name="name"
                                autoComplete="name"
                                size="small"
                                inputRef={register({
                                    required: "Nombre requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.name ? true : false}
                                helperText={errors.name ? errors.name.message : ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="lastName"
                                label="Apellido"
                                name="lastName"
                                autoComplete="lastName"
                                size="small"
                                inputRef={register({
                                    required: "Apellido requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.lastName ? true : false}
                                helperText={errors.lastName ? errors.lastName.message : ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="rut"
                                label="Rut"
                                name="rut"
                                autoComplete="rut"
                                size="small"
                                inputRef={register({
                                    required: "Rut requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.rut ? true : false}
                                helperText={errors.rut ? errors.rut.message : ""}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="sex"
                                label="Sexo"
                                name="sex"
                                autoComplete="sex"
                                size="small"
                                inputRef={register({
                                    required: "Sexo requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.sex ? true : false}
                                helperText={errors.sex ? errors.sex.message : ""}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                type="date"
                                id="birthDate"
                                label="Fecha de nacimiento"
                                name="birthDate"
                                autoComplete="birthDate"
                                size="small"
                                inputRef={register({
                                    required: "Fecha de nacimiento requerida"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.birthDate ? true : false}
                                helperText={errors.birthDate ? errors.birthDate.message : ""}
                            />
                        </Grid>


                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="nationality"
                                label="Nacionalidad"
                                name="nationality"
                                autoComplete="nationality"
                                size="small"
                                inputRef={register({
                                    required: "Nacionalidad requerida"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.nationality ? true : false}
                                helperText={errors.nationality ? errors.nationality.message : ""}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="university"
                                label="Universidad"
                                name="university"
                                autoComplete="university"
                                size="small"
                                inputRef={register({
                                    required: "Universidad requerida"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.university ? true : false}
                                helperText={errors.university ? errors.university.message : ""}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="collegeDegree"
                                label="Título"
                                name="collegeDegree"
                                autoComplete="collegeDegree"
                                size="small"
                                inputRef={register({
                                    required: "Título requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.collegeDegree ? true : false}
                                helperText={errors.collegeDegree ? errors.collegeDegree.message : ""}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <ReactHookFormSelect
                                id="specialist"
                                name="specialist"
                                className={classes.textField}
                                label="Especialista"
                                control={control}
                                size="small"
                                defaultValue={"false"}
                                variant="outlined"
                            >
                                <MenuItem value="true">Si</MenuItem>
                                <MenuItem value="false">No</MenuItem>
                            </ReactHookFormSelect>
                        </Grid>



                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="workRegion"
                                label="Región de trabajo"
                                name="workRegion"
                                autoComplete="workRegion"
                                size="small"
                                inputRef={register({
                                    required: "Región  de trabajo requerido"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.workRegion ? true : false}
                                helperText={errors.workRegion ? errors.workRegion.message : ""}
                            />
                        </Grid>


                        {/*                       <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="email"
                                label="Correo electrónico"
                                name="email"
                                size="small"
                                autoComplete="email"
                                inputRef={register({
                                    required: "Correo requerido", pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "Formato de correo inválido"
                                    }
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.email ? true : false}
                                helperText={errors.email ? errors.email.message : ""}
                            />
                        </Grid>

                          <Grid item xs={12} sm={6}>
                            <ReactHookFormSelect
                                id="code"
                                name="code"
                                className={classes.textField}
                                label="Código"
                                control={control}
                                size="small"
                                defaultValue={phoneCode}
                                variant="outlined"
                            >
                                <MenuItem value="+55">+55</MenuItem>
                                <MenuItem value="+56">+56</MenuItem>
                                <MenuItem value="+57">+57</MenuItem>
                                <MenuItem value="+58">+58</MenuItem>
                            </ReactHookFormSelect>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Teléfono"
                                id="number"
                                name="number"
                                variant="outlined"
                                size="small"
                                type="number"
                                inputRef={register({ required: "Campo requerido" })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.number ? true : false}
                                helperText={errors.number ? errors.number.message : ""}
                                fullWidth>
                            </TextField>
                        </Grid>

                      <Grid item xs={12} sm={6}>
                            <TextField label="Dirección"
                                id="address"
                                name="address"
                                variant="outlined"
                                size="small"
                                type="string"
                                inputRef={register({ required: "Campo requerido" })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.address ? true : false}
                                helperText={errors.address ? errors.address.message : ""}
                                fullWidth>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField label="Dirección de oficina"
                                id="OfficeAddress"
                                name="OfficeAddress"
                                variant="outlined"
                                size="small"
                                type="string"
                                inputRef={register({ required: "Campo requerido" })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.OfficeAddress ? true : false}
                                helperText={errors.OfficeAddress ? errors.OfficeAddress.message : ""}
                                fullWidth>
                            </TextField>
                        </Grid>
                         <Grid item xs={12} sm={6}>
                            <ReactHookFormSelect
                                id="clasification"
                                name="clasification"
                                className={classes.textField}
                                label="Clasificación"
                                control={control}
                                size="small"
                                defaultValue={"Prioritario"}
                                variant="outlined"
                            >
                                <MenuItem value="Prioritario">Prioritario</MenuItem>
                            </ReactHookFormSelect>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ReactHookFormSelect
                                id="departament"
                                name="departament"
                                className={classes.textField}
                                label="Departamento"
                                control={control}
                                size="small"
                                defaultValue={"Administrativo"}
                                variant="outlined"
                            >
                                <MenuItem value="Administrativo">Administrativo</MenuItem>
                                <MenuItem value="Alergología">Alergología</MenuItem>
                                <MenuItem value="Anestesiología">Anestesiología</MenuItem>
                                <MenuItem value="Cardiología">Cardiología</MenuItem>
                            </ReactHookFormSelect>
                        </Grid> */}
                    </Grid>
                    <DialogActions>
                        <Button
                            type="submit"
                            fullWidth
                            size="small"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            style={{ textTransform: 'capitalize', borderRadius: '20px' }}
                        >
                            Guardar
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    );
}

const useStyles = makeStyles((theme) => ({
    form: {
        marginTop: theme.spacing(2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    textField: {
        width: "100%"
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: '#f44336',
    },
    dialogTitle: {
        textAlign: 'Center'
    },

}));